@import './../scss/pk-accordion-group.variables';

:host(.accordion-item) {
  @apply flex flex-col bg-[color:--accordion--bg-color];
}

:host(.is-disabled) {
  @apply cursor-default opacity-60;
}
